// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__A9PZ6","form":"Modal_form__iQ7Kz","basket":"Modal_basket__qxz3C","content":"Modal_content__suaQU"};